import EmailUpdatePage from './EmailUpdatePage';
export default EmailUpdatePage;